import "./Highlighter.css";

// pick random value from array
function getRandomValueFromArray(array) {
  return array[Math.floor(Math.random() * array.length)];
}

function Highlighter({ text }) {
  const clipNumber = getRandomValueFromArray([1, 2, 3, 4]);
  return <span className={`Highlighted clipStyle${clipNumber}`}>{text}</span>;
}

export default Highlighter;
